import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PopoverViewEmployeePage } from './popover-view-employee.page';

const routes: Routes = [
  {
    path: '',
    component: PopoverViewEmployeePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PopoverViewEmployeePageRoutingModule {}
